"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { GraduationCap, MapPin, BookOpen, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const stats = [{
  value: "+10",
  label: "Años de trayectoria",
  icon: GraduationCap
}, {
  value: "19",
  label: "Departamentos alcanzados",
  icon: MapPin
}, {
  value: "+50",
  label: "Cursos disponibles",
  icon: BookOpen
}];
export default function NuestraIdentidadEducativa() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="nuestra-identidad-educativa" className="relative py-24 lg:py-32 overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/abstract_education_texture.png')] bg-cover bg-center opacity-[0.03] dark:opacity-[0.05]" />
        <div className="absolute inset-0 bg-gradient-to-b from-background via-transparent to-background" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="bg-card/60 dark:bg-card/40 backdrop-blur-2xl border border-border/50 shadow-2xl rounded-[2.5rem] p-8 md:p-12 lg:p-16 overflow-hidden relative">
            
            {}
            <div className="absolute -top-40 -right-40 w-96 h-96 bg-primary/10 rounded-full blur-3xl pointer-events-none" />
            <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-secondary/10 rounded-full blur-3xl pointer-events-none" />

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 relative z-10">
              
              {}
              <div className="lg:col-span-5 flex flex-col justify-center gap-10">
                <div className="space-y-2">
                  <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">
                    Nuestra Identidad
                  </h2>
                  <div className="h-1 w-20 bg-primary rounded-full" />
                </div>

                <div className="grid gap-8">
                  {stats.map((stat, i) => <div key={i} data-index={i} className="flex items-center gap-6 group">
                      <div className="flex-shrink-0 w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center text-primary group-hover:scale-110 group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-300">
                        <stat.icon className="w-8 h-8" />
                      </div>
                      <div>
                        <div className="font-mono text-4xl md:text-5xl font-bold text-foreground tracking-tighter">
                          {stat.value}
                        </div>
                        <div className="text-sm md:text-base text-muted-foreground uppercase tracking-widest font-semibold mt-1">
                          {stat.label}
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>

              {}
              <div className="lg:col-span-7 flex flex-col justify-center gap-6">
                <h3 className="text-2xl md:text-3xl font-semibold text-foreground leading-tight">
                  Transformando el futuro a través de la educación en todo el país.
                </h3>
                
                <div className="space-y-6 text-lg text-muted-foreground leading-relaxed">
                  <p>
                    En ECAP (Escuela de Capacitaciones Privadas), nos enorgullece ser un pilar fundamental en la formación técnica y profesional en todo el interior de Uruguay. Durante años, hemos acercado oportunidades educativas de alto nivel a cada rincón del país, democratizando el acceso al conocimiento práctico y actualizado.
                  </p>
                  <p>
                    Nuestra misión es clara: brindar educación de calidad y accesible para potenciar el desarrollo profesional de jóvenes, adultos y profesionales. Creemos firmemente que la capacitación es la llave para mejorar la empleabilidad y abrir nuevas puertas en el mercado laboral actual.
                  </p>
                  <p>
                    Con una amplia oferta que abarca desde oficios técnicos y estética, hasta bienestar, salud, deportes y áreas empresariales, nos adaptamos a las demandas reales del entorno. Contamos con instructores altamente calificados y modalidades flexibles que aseguran una experiencia de aprendizaje integral y transformadora.
                  </p>
                </div>

                <div className="pt-6">
                  <Button asChild size="lg" className="rounded-full px-8">
                    <Link to="https://wa.me/59896344395">
                      Contactar por WhatsApp
                      <ArrowRight className="ml-2 w-4 h-4" />
                    </Link>
                  </Button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>;
}